import type { FlowDefinition } from '../schema/flow'
import { FlowDefinitionSchema } from '../schema/flow'

/**
 * Flow ตัวอย่าง: สำรวจร้านอาหาร/ร้านค้าภาคสนาม
 * ใช้เป็น template ตอนสร้าง workflow ใหม่ และเป็น fixture ในเทส
 * (เทสบังคับว่า flow นี้ต้องผ่าน schema, ไม่มี error ใน checklist และเดินถึงขั้นตอนจบได้)
 */

const raw = {
  schemaVersion: 1,
  startNodeId: 'n_start',
  theme: {
    primaryColor: '#d81f26',
    fontId: 'sarabun',
    brandText: 'AYI Plus',
    brandSubtext: 'แบบสำรวจร้านค้า',
    logoAssetId: null,
  },
  nodes: [
    {
      id: 'n_start',
      key: 'Q1',
      type: 'inputText',
      title: 'ชื่อร้าน',
      description: 'กรอกชื่อร้านตามป้ายหน้าร้าน',
      position: { x: 0, y: 0 },
      required: true,
      placeholder: 'เช่น ร้านป้าแดง',
      multiline: false,
      inputMode: 'text',
      page: null,
    },
    {
      id: 'n_type',
      key: 'Q2',
      type: 'buttonChoice',
      title: 'ประเภทร้าน',
      description: 'เลือกประเภทที่ตรงที่สุด',
      position: { x: 0, y: 180 },
      required: true,
      options: [
        { id: 'opt_restaurant', label: 'ร้านอาหาร' },
        { id: 'opt_street', label: 'รถเข็น/แผงลอย' },
        { id: 'opt_grocery', label: 'ร้านของชำ' },
      ],
      page: null,
    },
    {
      id: 'n_menu',
      key: 'Q3',
      type: 'multiSelect',
      title: 'เมนูที่ขายดี',
      description: 'เลือกได้สูงสุด 3 อย่าง',
      position: { x: -260, y: 360 },
      required: true,
      maxSelect: 3,
      options: [
        { id: 'opt_noodle', label: 'ก๋วยเตี๋ยว' },
        { id: 'opt_ricedish', label: 'ข้าวราดแกง' },
        { id: 'opt_somtum', label: 'ส้มตำ' },
        { id: 'opt_friedrice', label: 'ข้าวผัด' },
      ],
      page: null,
    },
    {
      id: 'n_seasoning',
      key: 'Q4',
      type: 'dropdown',
      title: 'เครื่องปรุงหลักที่ใช้',
      description: '',
      position: { x: -260, y: 540 },
      required: true,
      options: [
        { id: 'opt_ajinomoto', label: 'อายิโนะโมะโต๊ะ' },
        { id: 'opt_other_brand', label: 'ยี่ห้ออื่น' },
        { id: 'opt_none', label: 'ไม่ใช้' },
      ],
      page: null,
    },
    {
      id: 'n_stock',
      key: 'Q5',
      type: 'inputText',
      title: 'สต๊อกคงเหลือ (ซอง)',
      description: 'กรอกเป็นตัวเลข',
      position: { x: -460, y: 720 },
      required: true,
      placeholder: '0',
      multiline: false,
      inputMode: 'number',
      page: null,
    },
    {
      id: 'n_reason',
      key: 'Q6',
      type: 'inputText',
      title: 'เหตุผลที่ไม่ใช้',
      description: 'สอบถามสั้น ๆ',
      position: { x: -60, y: 720 },
      required: false,
      placeholder: 'เช่น ลูกค้าไม่ชอบ',
      multiline: true,
      inputMode: 'text',
      page: null,
    },
    {
      id: 'n_grocery',
      key: 'Q7',
      type: 'multiSelect',
      title: 'สินค้าที่วางขาย',
      description: '',
      position: { x: 260, y: 360 },
      required: true,
      maxSelect: null,
      options: [
        { id: 'opt_seasoning', label: 'เครื่องปรุงรส' },
        { id: 'opt_drink', label: 'เครื่องดื่ม' },
        { id: 'opt_snack', label: 'ขนม' },
      ],
      page: null,
    },
    {
      id: 'n_photo',
      key: 'Q8',
      type: 'camera',
      title: 'ถ่ายภาพหน้าร้าน',
      description: 'ให้เห็นป้ายร้านชัดเจน',
      position: { x: 0, y: 900 },
      required: true,
      maxPhotos: 2,
      page: null,
    },
    {
      id: 'n_end',
      key: 'Q9',
      type: 'end',
      title: 'เสร็จสิ้น',
      description: '',
      position: { x: 0, y: 1080 },
      required: false,
      message: 'บันทึกข้อมูลเรียบร้อย ขอบคุณครับ/ค่ะ',
      page: null,
    },
  ],
  edges: [
    {
      id: 'e_start_type',
      source: 'n_start',
      target: 'n_type',
      priority: 0,
      condition: { kind: 'always' },
      label: '',
    },
    {
      id: 'e_type_grocery',
      source: 'n_type',
      target: 'n_grocery',
      priority: 0,
      condition: {
        kind: 'optionEquals',
        nodeKey: 'Q2',
        fieldName: 'answer',
        optionId: 'opt_grocery',
      },
      label: 'ร้านของชำ',
    },
    {
      id: 'e_type_menu',
      source: 'n_type',
      target: 'n_menu',
      priority: 1,
      condition: { kind: 'fallback' },
      label: 'ร้านอาหาร / รถเข็น',
    },
    {
      id: 'e_menu_seasoning',
      source: 'n_menu',
      target: 'n_seasoning',
      priority: 0,
      condition: { kind: 'always' },
      label: '',
    },
    {
      id: 'e_seasoning_stock',
      source: 'n_seasoning',
      target: 'n_stock',
      priority: 0,
      condition: {
        kind: 'optionEquals',
        nodeKey: 'Q4',
        fieldName: 'answer',
        optionId: 'opt_ajinomoto',
      },
      label: 'ใช้อายิโนะโมะโต๊ะ',
    },
    {
      id: 'e_seasoning_reason',
      source: 'n_seasoning',
      target: 'n_reason',
      priority: 1,
      condition: { kind: 'fallback' },
      label: 'กรณีอื่น',
    },
    {
      id: 'e_stock_photo',
      source: 'n_stock',
      target: 'n_photo',
      priority: 0,
      condition: { kind: 'always' },
      label: '',
    },
    {
      id: 'e_reason_photo',
      source: 'n_reason',
      target: 'n_photo',
      priority: 0,
      condition: { kind: 'always' },
      label: '',
    },
    {
      id: 'e_grocery_photo',
      source: 'n_grocery',
      target: 'n_photo',
      priority: 0,
      condition: { kind: 'always' },
      label: '',
    },
    {
      id: 'e_photo_end',
      source: 'n_photo',
      target: 'n_end',
      priority: 0,
      condition: { kind: 'always' },
      label: '',
    },
  ],
}

export function createFoodVendorFlow(): FlowDefinition {
  return FlowDefinitionSchema.parse(structuredClone(raw))
}

/** flow ว่างสำหรับเริ่มจากศูนย์ */
export function createBlankFlow(): FlowDefinition {
  return FlowDefinitionSchema.parse({
    schemaVersion: 1,
    startNodeId: 'n_first',
    nodes: [
      {
        id: 'n_first',
        key: 'Q1',
        type: 'inputText',
        title: 'คำถามแรก',
        description: '',
        position: { x: 0, y: 0 },
        required: true,
        placeholder: '',
        multiline: false,
        inputMode: 'text',
        page: null,
      },
      {
        id: 'n_last',
        key: 'Q2',
        type: 'end',
        title: 'เสร็จสิ้น',
        description: '',
        position: { x: 0, y: 220 },
        required: false,
        message: 'ขอบคุณครับ/ค่ะ',
        page: null,
      },
    ],
    edges: [
      {
        id: 'e_first_last',
        source: 'n_first',
        target: 'n_last',
        priority: 0,
        condition: { kind: 'always' },
        label: '',
      },
    ],
    theme: {},
  })
}

export const FLOW_TEMPLATES = ['blank', 'foodVendor'] as const
export type FlowTemplate = (typeof FLOW_TEMPLATES)[number]

export function createFlowFromTemplate(template: FlowTemplate): FlowDefinition {
  return template === 'foodVendor' ? createFoodVendorFlow() : createBlankFlow()
}
